module.exports = __webpack_public_path__ + "img/25.d723dd7f.jpg";